import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';

import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../components/login/service/login.service';
import jsPDF from 'jspdf';
applyPlugin(jsPDF);

import { tamilText } from '../fonts-pdf/tamil-language-code';
import { kannadaText } from '../fonts-pdf/kannada-language-code';
import { teluguText } from '../fonts-pdf/telugu-language-code';
import { hindiText } from '../fonts-pdf/hindi-language-code';
import { HttpErrorResponse } from '@angular/common/http';
import autoTable, { applyPlugin } from 'jspdf-autotable';
import { DatePipe, DecimalPipe } from '@angular/common';
import html2canvas from 'html2canvas';
import { debounceTime, forkJoin, Subject, Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { VoicemailService } from './service/voicemail.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';

@Component({
  selector: 'app-voice-mail',
  templateUrl: './voice-mail.component.html',
  styleUrl: './voice-mail.component.scss'
})
export class VoiceMailComponent {
  showModal = 'dialogue';
  records1: any = [];
  tableData: any = [];
  myBlob = new Blob();
  keywordPercent!: number;
  metric_percentage!: number;
  pause_scorePercentage!: number;
  storeId: any;
  fileIndex!: number;
  deadAirFileIndex!: number;
  transcriptModalData: any = [];
  dialogueList: any = [];
  keywordList: any = [];
  alertkeywordList: any = [];
  questionsData: any = [];
  englishQuestions: any = [];
  keywordSummary: any = [];
  mostUsedWords: any = [];
  transcriptModalData_T: any = [];
  dialogueList_T: any = [];
  keywordList_T: any = [];
  keywordList_Key: any = [];
  alertkeywordList_T: any = [];
  questionsData_T: any = [];
  englishQuestions_T: any = [];
  keywordSummary_T: any = [];
  mostUsedWords_T: any = [];
  input_1: any;
  input_2: any;
  speakerForm!: FormGroup;
  spinner!: boolean;
  bodySpinner: boolean = false;
  eyeShow: boolean = false;
  storeSpeakerName: any = [];
  tempVariable: any;
  display = 'none';
  filteredSpeaker: any = [];
  showTransOriginal: boolean = false;
  transcribedLg = ['English'];
  transcribedLgVariable!: string;
  showSelect: boolean = false;
  transcribedLg_T = ['English'];
  transcribedLgVariable_T!: string;
  showSelect_T: boolean = false;
  store_DSName: any = [];
  filtered_DSName: any = [];
  showRow: boolean = false;
  dialogueIndex!: number;
  inputType = 'button';
  dialogueScriptForm!: FormGroup;
  inputValue!: string;
  transcriptIndex!: number;
  editedTranscript: any = [];
  searchText: any;
  searchTextTable = '';
  searchForm!: FormGroup;
  getSearchText: any;
  call_category: any = [];
  QAMetricsData: any = [];
  metricsMatches: any = [];
  modulationData: any = [];
  callCategoryIndex!: number;
  showPagination = false;
  page = 1;
  limit = 25;
  total_pages!: number;
  audioPayload: any = {};
  metricsMScore!: number;
  metricsTotalScore!: number;
  metricsTotalScore2!: number;
  metricsTotalScoreArray: any = [];
  metricsCommentsArray: any = [];
  metricsMComments = '';
  showManualInput = false;
  getMetricsIndex!: number;
  getMetricsIndex2!: number;
  metricsTotal!: number;
  getRecordIndex!: number;
  infoDetails: any = [];
  infoTopicsName!: string;
  infoTopicsId!: string;
  infoForm!: FormGroup;
  getInfoTopics: any = [];
  splitPattern = new RegExp('[,;]');
  disableInput = false;
  infoEditShow = false;
  getInfoFormValue: any = [];
  getInfoTopicId!: string;
  userDetails: any;
  setTopicId!: string;
  getTableIndex!: number;
  sortingShow: boolean = false;
  selectedRow!: number;
  audioFileIndex = -1;
  filereader: any = new FileReader();
  audioSafeUrl!: SafeUrl;
  blobFile!: File;
  showsentiment = '';
  showSentimentWords = '';
  sentimentGraphData: any;
  sentimentGraphCustomer: any;
  sentimentGraphAgent: any;
  sentimentData: any = [];
  sentimentPostiveWords: any = [];
  sentimentNegativeWords: any = [];
  sentimentNeutralWords: any = [];
  customerPostiveWords: any = [];
  customerNegativeWords: any = [];
  customerNeutralWords: any = [];
  agentPostiveWords: any = [];
  agentNegativeWords: any = [];
  agentNeutralWords: any = [];
  tableTrVar!: number;
  audioSpinner = false;
  blobUrl: any;
  audio: any;
  showPlayPause: boolean = false;
  showModalAudioTag: boolean = false;
  @ViewChild('searchSelect') searchSelect!: ElementRef;
  @ViewChild('conversationAcButton') conversationAcButton!: ElementRef;
  @ViewChild('speakerNameAcButton') speakerNameAcButton!: ElementRef;
  // @ViewChild(DaterangepickerDirective, { static: false })
  @ViewChild('searchInputDialog') searchInputDialog!: ElementRef;
  @ViewChild('restrictScore') restrictScore!:ElementRef;
  // @ViewChild('errorcomment') errorcomment!: ElementRef;
  pickerDirective!: DaterangepickerDirective;
  dateTime!: Date;
  getDateData: any;
  endDate: any;
  getInputSearchValue!: string;
  selectedSearchOption = 'default';
  inputSub!: Subscription;
  bound = 'inbound';
  downloadReportName = 'report';
  downloadSpinner: boolean = false;
  downloadBtnSpinner: boolean = false;
  showAccordionData: boolean = false;
  getDownload!: string;
  getDownloadIndex!: number;
  axixY = 52;
  tempAxix!: number;
  HeightDialogList = 30;
  transcriptMinimizedBoolean: boolean = false;
  transcriptMinimizedHeader!: string;
  modalScreenSize!: string;
  submitted!: boolean;
  infoDetailsLanguage!: string;
  usersRole!: number;
  transcribe_language!: string;
  awsUpdatedApiData: any = [];
  ttfName!: string;
  fontName!: string;
  fontStyle: any;
  fontLanguage: any;
  translateResponseDataTemp: any = [];
  translateResponseData: any[] = [];
  translateResponseData_original: any = [];
  translateResponseData_originalTemp: any = [];
  modalArray = [
    'dialogue',
    'keyword',
    'alertKeywords',
    'questions',
    'summary',
    'mostUsedWords',
    'transcript',
  ];
  sentimentArray = ['overall', 'customer', 'agent'];
  sentimentWordsArray = ['positive', 'neutral', 'negative'];
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  displayTranscriptModal = 'none';
  emailForm!: FormGroup;
  deadAirData: any = [];
  deadAirDataNew: any = [];
  deadAirDurationData: any = [];
  softHoldData: any = [];
  softHoldDurationData: any = [];
  private readonly notifier: NotifierService;
  tranlateLanguages = [
    { lang: 'English', value: 'en' },
    { lang: 'Spanish', value: 'es' },
    { lang: 'Japanese', value: 'ja' },
    { lang: 'Vietnamese', value: 'vi' },
    { lang: 'Arabic', value: 'ar' },
    { lang: 'Bengali', value: 'bn' },
    { lang: 'Chinese', value: 'zh' },
    { lang: 'Dutch', value: 'nl' },
    { lang: 'Finnish', value: 'fi' },
    { lang: 'French', value: 'fr' },
    { lang: 'German', value: 'de' },
    { lang: 'Greek', value: 'el' },
    { lang: 'Hindi', value: 'hi' },
    { lang: 'Tamil', value: 'ta' },
    { lang: 'Urdu', value: 'ur' },
    { lang: 'Kannada', value: 'kn' },
    { lang: 'Telugu', value: 'te' },
    { lang: 'Marathi', value: 'mr' },
  ];
  selectedTranslate: any;
  selectedTranslate_1: any;
  getTranslateLanguage = 'en';
  fromLanguage!: string;
  toLanguage!: string;
  translateSpinner: boolean = false;
  displayName!: string;
  editedTextBoolean: boolean = false;
  editedTextPayload: any;
  showActionIcons: boolean = false;
  actionIconsIndex = -1;
  lineChartData: any = {
    labels: [],
    datasets: [
      {
        label: 'Sentiment Score',
        data: [],
        fill: false,
        datalabel: true,
        tension: 0.5,
        borderColor: '#36A2EB',
        backgroundColor: '#9BD0F5',
        pointBackgroundColor: (context: any) => {
          var index = context.dataIndex;
          var value = context.dataset.data[index];
          return value < 0 ? 'red' : '#565c78';
        },
      },
    ],
  };
  // public lineChartOptions: ChartOptions<'line'> = {
  //   responsive: true,
  //   scales: {
  //     y: {
  //       suggestedMin: -1.0,
  //       suggestedMax: 1.0,
  //     },
  //   },
  // };
  public lineChartLegend = true;
  //
  public tableSearch!: string;
  tableSearchUpdate = new Subject<string>();
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['bold', 'italic'], ['fontSize']],
  };
  showMultiSelect: boolean = false;
  storeDeleteApi: any[] = [];
  selectedAllIndex: boolean = false;
  deleteIndexArray: any = [];
  deleteIndexResult: any = [];
  storeFileIdArray: any = [];
  condition_email!: any;
  clientcodeId:any;
  metricFullscreen:boolean=false;
  softHold_Totalduration:any;
  selectedMetricsIndex:any;
  llm_sentiment_summary:any;
  sentimentRawData:any={};
  format_agent_score:any='1.0-1';
  showingRecords:number=0;
  metricsMComments_valid:boolean=true;
  metricsMScore_valid:boolean =true;
  constructor(
    private voicemailService: VoicemailService,
    private fb: FormBuilder,
    private notifierService: NotifierService,
   private service:LoginService,
    private sanitizer: DomSanitizer,
    private renderer:Renderer2,
    private el:ElementRef,
    private decimalPipe: DecimalPipe,
  ) {
    this.notifier = notifierService;
    this.tableSearchUpdate.pipe(debounceTime(400)).subscribe((value:any) => {
      this.searchTableData(value);
    });
    
  }


  ngOnChanges() {
    this.getSearchText = this.searchForm.controls['searchInput'].value;
  }

  ngOnInit(): void {
    this.dateTime = new Date();
     
  //  this.userDetails = this.appComponent.userDetailsAppComp;
  
    this.audioPayload = {
      date_filter: 'false',
      pageno: this.page,
      limit: this.limit,
      outbound: this.bound === 'inbound' ? false : true,
      sort: [{ property: 'created_date', dir: 'DESC' }],
      search: this.searchForm?.controls['searchInput'].value
        ? this.searchForm?.controls['searchInput'].value
        : '',
      meet_user: 'N',
      audio_call_type_status:'voice'
    };
    this.loadAudioRecords();
    this.speakerForm = this.fb.group({
      speakerArrayForm: this.fb.array([]),
    });

    this.dialogueScriptForm = this.fb.group({
      input: [null, Validators.required],
    });

    this.searchForm = this.fb.group({
      searchSelect: [''],
      searchInput: [''],
    });
    this.searchForm.controls['searchSelect'].setValue('default');

    this.infoForm = this.fb.group({
      display_file_name: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:[A-Za-z\/\&\-])+(?:\s[A-Za-z\/\&\-]+)*[A-Za-z]$/)]],
      caller_name: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      agent_name: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      topic: [null],
      own_key_words: [null],
      alert_keywords: [null],
      sensitive_words: [null],
      hide_keywords: [null],
      delete_words: [null],
      conversation: [null,Validators.pattern(/^[A-Za-z]+(?:[A-Za-z\/\&\-])+(?:\s[A-Za-z\/\&\-]+)*[A-Za-z]$/)],
      language: [null],
    });
    this.emailForm = this.fb.group({
      to: [
        null,
        [
          Validators.required,
          Validators.pattern(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/),
        ],
      ],
      cc: [
        null,
        [
          Validators.required,
          Validators.pattern(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/),
        ],
      ],
      subject: ['', [Validators.required]],
      htmlContent: ['', [Validators.required]],
    });

    this.transcribedLgVariable = this.transcribedLg[0];
    this.transcribedLgVariable_T = this.transcribedLg_T[0];

    
    
  }

  get speakerArrayForm() {
    return this.speakerForm.controls['speakerArrayForm'] as FormArray;
  }
  speakerArrayInput() {
    const lessonForm = this.fb.group({
      speakerControl: [null],
    });

    this.speakerArrayForm.push(lessonForm);
  }

  // get f(): { [key: string]: AbstractControl } {
  //   return this.emailForm.controls;
  // }

  boundChange() {
    this.audioPayload = {
      date_filter: 'false',
      pageno: this.page,
      limit: this.limit,
      outbound: this.bound === 'inbound' ? false : true,
      sort: [{ property: 'created_date', dir: 'DESC' }],
      search: this.searchForm?.controls['searchInput'].value
        ? this.searchForm?.controls['searchInput'].value
        : '',
      meet_user: 'N',
      audio_call_type_status:'voice'
    };
    this.loadAudioRecords();
    this.closeAudioTag();
    this.tableSearch = '';
    this.getDateData = '';
    this.pickerDirective?.clear();
  }

  loadAudioRecords() {
    this.bodySpinner = true;
    this.deleteIndexArray = [];
    this.voicemailService.postAudio(this.audioPayload).subscribe({
      next: (sub:any) => {
        this.records1 = sub;
        this.tableData = this.records1.records;
        if(this.tableData.length){
          this.clientcodeId = this.tableData[0]['client_code']['$oid'];
        }
        this.getMatchedCategory(this.tableData);
        this.total_pages = this.records1.total_pages;
        for (let i = 0; this.tableData.length > i; i++) {
          this.deadAirData.push(this.tableData[i].dead_air?.[0]);
          this.deadAirDataNew.push(this.tableData[i].dead_air);
          this.deleteIndexArray.push(false);
          this.softHoldData.push(this.tableData[i].hold_key)

        }
        this.bodySpinner = false;
        if(this.tableData.length==this.limit){
          this.showingRecords = this.limit * this.page;
        }else{
          this.showingRecords = this.limit * (this.page - 1) + this.tableData.length;
        }
        
      },
      error: (err: any) => {
        console.log('fetch audio records error', err);
        this.bodySpinner = false;
      },
      complete: () => {
        this.bodySpinner = false;
      },
    });
  }

  getMatchedCategory(data: any) {
    let merged: any = [];
    for (let index = 0; index < data.length; index++) {
      if (data[index].call_category.length !== 0) {
        const reproducePauseArr = data[index].call_category.map(function (
          o: any
        ) {
          if (o.matched === 'Y') {
            return o;
          }
        });
        const arr = reproducePauseArr.filter((elm: any) => elm);
        data[index].category_matched = [...arr];
        merged = [...data];
      } else {
        merged = [...data];
      }
    }
    this.tableData = [...merged];
  }

  playAudioFile(index: any) {
    this.audioSafeUrl = '';
    this.audioFileIndex = index;
    this.audioSpinner = true;
    this.showPlayPause = false;
    const fileName = this.tableData[index].file_name;
    this.tableData[index].read = 'Y';
    this.voicemailService.getAudioFile(fileName).subscribe({
      next: async (response:any) => {
        this.myBlob = new Blob([response as Blob]);
        this.blobFile = new File([this.myBlob], 'myaudio.mp3', {
          type: 'audio/mp3',
        });
        this.blobUrl = URL.createObjectURL(this.blobFile);
        this.audioSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.blobUrl
        );
        this.audioSpinner = false;
        this.showModalAudioTag = true;
      },
      error: (err:HttpErrorResponse) => {
        this.audioSpinner = false;
      },
    });
  }

  audioTagChange(event: any) {
    if (event === 'play') {
      this.showPlayPause = true;
    } else if (event === 'pause') {
      this.showPlayPause = false;
    }
  }

  playAD(value: string) {
    this.audio = document.getElementById('audioTagAnalysis');
    this.showPlayPause = !this.showPlayPause;
    if (value === 'pause') {
      this.audio.pause();
    } else if (value === 'play') {
      this.audio.play();
    }
  }

  pageChanged(event: any) {
    this.deadAirData = [];
    this.deadAirDataNew = [];
    this.softHoldData = [];
    this.page = event;
    this.audioPayload.pageno = event;
    if (this.selectedSearchOption === 'default' || this.selectedSearchOption=='fileid') {
      this.loadAudioRecords();
    } else if (this.selectedSearchOption === 'keyword') {
      this.getKeywordSearchData();
    } else if (this.selectedSearchOption === 'date') {
      this.loadAudioRecords();
    }
  }

  modalHeading(value: string) {
    this.modalArray.forEach((item) => {
      if (value == item) {
        this.showModal = value;
      }
    });
  }

  sentimentHeading(value: string) {
    this.sentimentArray.forEach((item) => {
      if (value === item) {
        this.showsentiment = value;
      }
    });
    if (this.showsentiment === 'overall') {
      this.lineChartData.datasets[0].data = this.sentimentGraphData;
      this.lineChartData.labels = this.sentimentGraphData;
    } else if (this.showsentiment === 'customer') {
      this.lineChartData.datasets[0].data = this.sentimentGraphCustomer;
      this.lineChartData.labels = this.sentimentGraphCustomer;
    } else if (this.showsentiment === 'agent') {
      this.lineChartData.datasets[0].data = this.sentimentGraphAgent;
      this.lineChartData.labels = this.sentimentGraphAgent;
    }
  }

  sentimentWordsHeading(value: string) {
    this.sentimentWordsArray.forEach((item) => {
      if (value === item) {
        this.showSentimentWords = value;
      }
    });
  }

  tableBack(index: number) {
    this.tableTrVar = index;
  }

  getSentimentFun(index: number) {
    const ind = index;
    this.tableData[index].read = 'Y';
    this.sentimentRawData['sentiment_text']=this.tableData[index]['sentiment_text'];
    this.sentimentRawData['sentiments_icon']=this.tableData[index]['sentiments_icon'];
    this.sentimentData = this.tableData[index];
    this.sentimentPostiveWords = this.tableData[index]?.positive_words;
    this.sentimentNeutralWords = this.tableData[index]?.neutral_words;
    this.sentimentNegativeWords = this.tableData[index]?.negative_words;
    this.customerPostiveWords = this.tableData[index]?.customer_positive_words;
    this.customerNeutralWords = this.tableData[index]?.customer_neutral_words;
    this.customerNegativeWords = this.tableData[index]?.customer_negative_words;
    this.agentPostiveWords = this.tableData[index]?.agent_positive_words;
    this.agentNeutralWords = this.tableData[index]?.agent_neutral_words;
    this.agentNegativeWords = this.tableData[index]?.agent_negative_words;
    this.sentimentGraphData = this.tableData[index]?.sentiment_graph;
    this.sentimentGraphCustomer = this.tableData[index]?.customer_graph;
    this.sentimentGraphAgent = this.tableData[index]?.agent_graph;
  }

  clearSentimentData() {
    this.sentimentGraphData = [];
    this.lineChartData.datasets[0].data = [];
    this.sentimentData = [];
    this.sentimentRawData = {};
    this.sentimentPostiveWords = [];
    this.sentimentNeutralWords = [];
    this.sentimentNegativeWords = [];
    this.customerPostiveWords = [];
    this.customerNeutralWords = [];
    this.customerNegativeWords = [];
    this.agentPostiveWords = [];
    this.agentNeutralWords = [];
    this.agentNegativeWords = [];
    this.lineChartData.labels = [];
    this.sentimentGraphCustomer = [];
    this.sentimentGraphAgent = [];
    this.showsentiment = '';
    this.showSentimentWords = '';
  }

  getTranscriptFun(index: number, name: string) {
    
    this.searchText = '';
    this.spinner = true;
    this.fileIndex = index;
    this.storeId = this.tableData[this.fileIndex]?.file_id.$oid;
    this.llm_sentiment_summary = this.tableData[this.fileIndex]['llm_sentiment_summary'];
    if (this.transcribedLg_T.length > 1) {
      this.transcribedLg_T.shift();
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (name == 'dialogue') {
      this.voicemailService.getTranscriptData(this.storeId,this.usersRole).subscribe(
        (sub:any) => {
          this.transcriptModalData_T = sub;
          const language = this.transcriptModalData_T.language;
          this.transcribe_language = language;
          this.transcriptSelectedLgFunTranscriptModal(language);
          this.dialogueList_T = this.transcriptModalData_T.dialogues_list;
          this.keywordList_T = this.transcriptModalData_T.own_keywords_list;
          this.alertkeywordList_T = this.transcriptModalData_T.alert_words_list;
          this.tableData[index].read = 'Y';
          this.keywordList_T.sort((a: any, b: any) => {
            return b.count - a.count;
          });
          this.alertkeywordList_T.sort((a: any, b: any) => {
            return b.count - a.count;
          });
          if (this.storeSpeakerName.length === 0) {
            for (let i = 0; this.dialogueList_T.length > i; i++) {
              const speakerName = this.dialogueList_T[i].original_speaker;
              const DSName = this.dialogueList_T[i].display_speaker;
              this.store_DSName.push(DSName);
              this.storeSpeakerName.push(speakerName);
            }
            this.filtered_DSName = this.removeDuplicates(this.store_DSName);
            this.filteredSpeaker = this.removeDuplicates(this.storeSpeakerName);

            for (let i = 0; this.filteredSpeaker.length > i; i++) {
              this.speakerArrayInput();
            }
          }
          this.globalSearchHighlighterFun();
          this.spinner = false;
        },
        (error:HttpErrorResponse) => {
          console.log('Transcript got error', error);
          this.spinner = false;
        }
      );
    }
    if (name == 'transcript') {
      this.voicemailService.getTranscriptData(this.storeId,this.usersRole).subscribe(
        (sub:any) => {
         this.transcriptModalData_T = sub;
          let language = 'hi';
          if(this.showModal=='summary'){
              language = 'en';
          }else{
              language = this.transcriptModalData_T.language;
          }
          this.transcribe_language = language;
          this.transcriptSelectedLgFunTranscriptModal(language);
          this.dialogueList_T = this.transcriptModalData_T.dialogues_list;
          this.keywordList_T = this.transcriptModalData_T.own_keywords_list;
          this.alertkeywordList_T = this.transcriptModalData_T.alert_words_list;
          this.spinner = false;
          this.tableData[index].read = 'Y';
          if (this.condition_email == 'jovave8965@newnime.com') {
            this.keywordSummary_T = this.transcriptModalData_T.keywords;
            this.mostUsedWords_T = this.transcriptModalData_T.most_used_words;
          } else {
            if (language.slice(0, 2) === 'en') {
              this.keywordSummary_T = this.transcriptModalData_T.keywords;
              this.mostUsedWords_T = this.transcriptModalData_T.most_used_words;
            } else {
              this.keywordSummary_T = this.transcriptModalData_T.spanish_keywords;
              this.mostUsedWords_T =
                this.transcriptModalData_T.spanish_most_used_words;
            }
          }

          this.keywordList_T.sort((a: any, b: any) => {
            return b.count - a.count;
          });
          this.alertkeywordList_T.sort((a: any, b: any) => {
            return b.count - a.count;
          });
          this.globalSearchHighlighterFun();
        },
        (error:HttpErrorResponse) => {
          console.log('Transcript got error', error);
          this.spinner = false;
        }
      );
    }

    

    if (name == 'questions') {
      
      this.voicemailService.getQuestionData(this.storeId,this.usersRole).subscribe(
        (sub:any) => {
           this.spinner = false;
          this.questionsData_T = sub;
          this.transcribe_language = this.questionsData_T.language;
          
            if (this.questionsData_T.language.slice(0, 2) === 'en') {
              this.englishQuestions_T = this.questionsData_T.english_questions;
            } else {
              this.englishQuestions_T = this.questionsData_T.spanish_questions;
            }
           
          this.transcriptSelectedLgFunTranscriptModal(
            this.questionsData_T.language
          );
          this.globalSearchHighlighterFun();
          
        },
        (error:HttpErrorResponse) => {
          console.log('transcript keywords error: ', error);
           this.spinner = false;
        }
      );
    }
  }

  transcriptSelectedLgFunTranscriptModal(language: string) {
    if (language.slice(0, 2) === 'es') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Spanish');
      }
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
      this.showSelect_T = true;
    }
    if (language.slice(0, 2) === 'hi') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Hindi');
      }
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
      this.showSelect_T = true;
    }

     if (language.slice(0, 2) === 'ar') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Arabic');
      }
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
      this.showSelect_T = true;
    }

    if (language.slice(0, 2) === 'kn') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Kannada');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language.slice(0, 2) === 'en') {
      this.showSelect_T = false;
    }
    if (this.condition_email == 'jovave8965@newnime.com') {
      if (language.slice(0, 2) === 'ta') {
        // if (this.transcribedLg_T.length < 2) {
        //   this.transcribedLg_T.unshift('Tamil');
        // }
        this.showSelect_T = false;
        // this.transcribedLgVariable_T = this.transcribedLg_T[0];
      }
    }
    else {
      if (language.slice(0, 2) === 'ta') {
        if (this.transcribedLg_T.length < 2) {
          this.transcribedLg_T.unshift('Tamil');
        }
        this.showSelect_T = true;
        this.transcribedLgVariable_T = this.transcribedLg_T[0];
      }
    }
    if (language.slice(0, 2) === 'mr') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Marathi');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language.slice(0, 2) === 'te') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Telugu');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language.slice(0, 2) === 'gu') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Gujarati');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language.slice(0, 2) === 'bn') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Bengali');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
  }

  transcriptSelectedLgFun(language: string) {
    if (language.slice(0, 2) === 'es') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Spanish');
      }
      this.transcribedLgVariable = this.transcribedLg[0];
      this.showSelect = true;
    }
    if (language.slice(0, 2) === 'hi') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Hindi');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }

     if (language.slice(0, 2) === 'ar') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Arabic');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }

    if (language.slice(0, 2) === 'kn') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Kannada');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language.slice(0, 2) === 'en') {
      this.showSelect = false;
    }
    if (this.condition_email == 'jovave8965@newnime.com') {
      if (language.slice(0, 2) === 'ta') {
        // if (this.transcribedLg.length < 2) {
        //   this.transcribedLg.unshift('Tamil');
        // }
        this.showSelect = false;
        // this.transcribedLgVariable = this.transcribedLg[0];
      }
    } else {
      if (language.slice(0, 2) === 'ta') {
        if (this.transcribedLg.length < 2) {
          this.transcribedLg.unshift('Tamil');
        }
        this.showSelect = true;
        this.transcribedLgVariable = this.transcribedLg[0];
      }
    }
    if (language.slice(0, 2) === 'mr') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Marathi');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language.slice(0, 2) === 'te') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Telugu');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language.slice(0, 2) === 'gu') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Gujarati');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language.slice(0, 2) === 'bn') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Bengali');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
  }

  clearKeywordDetailsTranscriptModal() {
    setTimeout(() => {
      this.modalScreenSize = '';
      this.CancelEditedText();
      this.speakerForm.reset();
      this.speakerArrayForm.reset();
      this.dialogueScriptForm.reset();
      this.transcriptModalData_T = [];
      this.dialogueList_T = [];
      this.keywordList_T = [];
      // this.infoDetails = [];
      this.alertkeywordList_T = [];
      this.keywordSummary_T = [];
      this.mostUsedWords_T = [];
      this.questionsData_T = [];
      this.englishQuestions_T = [];
      if (this.transcribedLg_T.length > 1) {
        this.transcribedLg_T.shift();
      }
      this.showSelect_T = false;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }, 400);
    this.searchText = '';
    this.llm_sentiment_summary="";
  }

  clearKeywordDetails() {
    setTimeout(() => {
      this.CancelEditedText();
      // this.speakerForm.reset();
      // this.speakerArrayForm.reset();
      // this.dialogueScriptForm.reset();
      this.transcriptModalData = [];
      this.dialogueList = [];
      this.keywordList = [];
      this.infoDetails = [];
      this.alertkeywordList = [];
      this.keywordSummary = [];
      this.mostUsedWords = [];
      this.questionsData = [];
      this.englishQuestions = [];
      if (this.transcribedLg.length > 1) {
        this.transcribedLg.shift();
      }
      this.showSelect = false;
      this.transcribedLgVariable = this.transcribedLg[0];
    }, 400);
    this.searchText = '';
  }

  removeDuplicates(value: any) {
    return value.filter(
      (item: any, index: any) => value.indexOf(item) === index
    );
  }

  updateSpeaker() {
    const value = this.speakerForm.value;
    let updatedSpeaker = [];

    for (let i = 0; this.filtered_DSName.length > i; i++) {
      let obj = {
        old_speaker_name: null,
        new_speaker_name: null,
      };
      obj.old_speaker_name = this.filtered_DSName[i];
      obj.new_speaker_name = value.speakerArrayForm[i].speakerControl;
      updatedSpeaker.push(obj);
    }
    for (let i = 0; this.dialogueList_T.length > i; i++) {
      for (let j = 0; updatedSpeaker.length > j; j++) {
        if (updatedSpeaker[j].new_speaker_name) {
          if (
            this.dialogueList_T[i].display_speaker ===
            updatedSpeaker[j].old_speaker_name
          ) {
            this.dialogueList_T[i].display_speaker =
              updatedSpeaker[j].new_speaker_name;
          }
        }
      }
    }

    this.voicemailService
      .updateSpeakerName(this.storeId, {
        edited_display_text: this.dialogueList_T,
      })
      .subscribe(
        (sub:any) => {
          this.notifier.notify('default', 'Updated Successfully!');
          this.speakerForm.reset();
        },
        (error:HttpErrorResponse) => {
          console.log('updated speaker name error: ', error);
        }
      );
  }

  showOriginalTranscript(event: any) {
    this.showTransOriginal = !this.showTransOriginal;
    this.searchText = '';
    this.globalSearchHighlighterFun();
  }
  getEditingText(index: number) {
    this.dialogueIndex = index;
    this.inputValue = this.dialogueList_T[this.dialogueIndex]?.edited_text;
    this.showRow = true;
    if (this.transcribedLgVariable_T === 'English') {
      this.dialogueScriptForm.controls['input'].setValue(
        this.dialogueList_T[index]?.edited_text
      );
    } else {
      this.dialogueScriptForm.controls['input'].setValue(
        this.dialogueList_T[index]?.spanish_edited_text
      );
    }
  }

  CancelEditedText() {
    this.showRow = false;
  }

  updateAwsTranscriptData() {
    // if (this.transcribe_language !== 'ta-IN') {
    //   const result = this.dialogueScriptForm.controls['input'].value;
    //   const obj = {
    //     dest:
    //       this.transcribedLgVariable_T === 'English'
    //         ? this.transcribe_language
    //         : 'en-US',
    //     source:
    //       this.transcribedLgVariable_T === 'English'
    //         ? 'en-US'
    //         : this.transcribe_language,
    //     text: this.dialogueScriptForm.controls['input'].value,
    //   };
    //   this.voicemailService.updateAwsTranscript(obj).subscribe({
    //     next: (response) => {
    //       this.awsUpdatedApiData = response;
    //       this.updateTranscript();
    //       this.showRow = false;
    //     },
    //     error: (err) => {
    //       console.log('transcript update error', err);
    //     },
    //   });
    // } else {
    this.updateTranscript();
    // }
  }

  // updateTranscript() {
  //   const result = this.dialogueScriptForm.controls['input'].value;
  //   if (this.transcribe_language !== 'ta-IN') {
  //     if (this.transcribedLgVariable_T === 'English') {
  //       if (this.transcribedLg_T.length > 1) {
  //         this.dialogueList_T[this.dialogueIndex].edited_text = result;
  //         this.dialogueList_T[this.dialogueIndex].spanish_edited_text =
  //           this.awsUpdatedApiData.result;
  //       } else {
  //         this.dialogueList_T[this.dialogueIndex].edited_text =
  //           this.awsUpdatedApiData.result;
  //       }
  //     } else {
  //       this.dialogueList_T[this.dialogueIndex].spanish_edited_text = result;
  //       this.dialogueList_T[this.dialogueIndex].edited_text =
  //         this.awsUpdatedApiData.result;
  //     }
  //   } else {
  //     if (this.transcribedLgVariable_T === 'Tamil') {
  //       this.dialogueList_T[this.dialogueIndex].spanish_edited_text = result;
  //     }
  //     if (this.transcribedLgVariable_T === 'English') {
  //       this.dialogueList_T[this.dialogueIndex].edited_text = result;
  //     }
  //   }
  //   this.editedTranscript.push(this.dialogueList_T[this.dialogueIndex]);
  //   this.voicemailService
  //     .updateTranscription(this.storeId, {
  //       edited_display_text: this.editedTranscript,
  //     })
  //     .subscribe(
  //       (sub) => {
  //         this.showRow = false;
  //         this.notifier.notify('default', 'Updated Successfully!');
  //         this.editedTranscript = [];
  //       },
  //       (error) => {
  //         console.log('transcription update error', error);
  //       }
  //     );
  // }

  updateTranscript() {
    this.editedTranscript = [];
    const result = this.dialogueScriptForm.controls['input'].value;
    if (this.transcribedLgVariable_T === 'English' || this.transcribe_language.slice(0, 2) === 'en') {
      this.dialogueList_T[this.dialogueIndex].edited_text = result;
    } else {
      this.dialogueList_T[this.dialogueIndex].spanish_edited_text = result;
    }
    this.editedTranscript.push(this.dialogueList_T[this.dialogueIndex]);
    this.voicemailService
      .updateTranscription(this.storeId, {
        edited_display_text: this.editedTranscript,
      })
      .subscribe(
        (sub:any) => {
          this.showRow = false;
          this.notifier.notify('default', 'Updated Successfully!');
          this.editedTranscript = [];
        },
        (error:HttpErrorResponse) => {
          console.log('transcription update error', error);
        }
      );
  }


  CallCategoryIndex(index: number) {
    this.callCategoryIndex = index;
    this.call_category = this.tableData[index].call_category;
    this.modulationData = this.tableData[index].modulation_matches;
    this.tableData[index].read = 'Y';
  }

  clearCallCategory() {
    setTimeout(() => {
      this.call_category = [];
      this.modulationData = [];
      this.deadAirDurationData = [];
      this.deadAirFileIndex = -1;
      this.softHoldDurationData = [];
    }, 400);
  }

  getQAMetricsData(index: number) {
    //this.renderer.setStyle(this.errorcomment.nativeElement,'display','none');
    this.selectedMetricsIndex=index;
    this.metricFullscreen=true;
    this.spinner = true;
    this.storeId = this.tableData[index]?.file_id.$oid;
    const obj: any = { fileid: this.storeId };
    this.voicemailService.getQAMetric(obj).subscribe(
      (sub:any) => {
        this.QAMetricsData = sub;
        this.metricsMatches = this.QAMetricsData.qa_metrics.metrics_matches;
        this.spinner = false;
        this.tableData[index].read = 'Y';
        let manual_score_data = this.QAMetricsData.qa_metrics.manual_score_data;
       // const length = this.metricsMatches.length;
       const length = manual_score_data.length;
        this.metricsTotal = this.QAMetricsData.qa_metrics.manual_total;
        for (let i = 0; length > i; i++) {
          this.metricsTotalScoreArray.push(
            manual_score_data[i]?.manual_score
          );
          this.metricsCommentsArray.push(
            manual_score_data[i]?.manual_comments
          );
        }
        // if(this.metricsMatches.length > 0){
        //  let check_agent_score = this.metricsMatches.filter((mM:any)=>mM['agent_score']=='Yes').length;
        //  if(check_agent_score > 0){
        //   this.QAMetricsData.qa_metrics['agent_total']=0;
        //   this.QAMetricsData.qa_metrics['metric_score']=0;
        //  }
         // }
        
      },
      (error:HttpErrorResponse) => {
         
      }
    );
  }

  showManualField(index: any) {
    this.showManualInput = true;
    this.getMetricsIndex = index;

    this.metricsMComments = this.metricsCommentsArray[this.getMetricsIndex];
    this.metricsMScore = this.metricsTotalScoreArray[this.getMetricsIndex];
   // this.renderer.setStyle(this.errorcomment.nativeElement,'display','none');
  }

  sendMetricIndex(index: number, value: string) {
 
   
    this.getMetricsIndex2 = index;
    if (value === 'score') {
     // if(parseInt(this.restrictScore.nativeElement.value) <= parseInt(this.restrictScore.nativeElement.max)){
     var numberValidate_reg:any='/^\d*$/';
     if (!numberValidate_reg.test(value)) {
         this.metricsMScore_valid = false;
          return;
     }else{
       this.metricsMScore_valid  =true;
     }
      
        if (this.getMetricsIndex === this.getMetricsIndex2) {
          this.metricsTotalScoreArray[this.getMetricsIndex] = this.metricsMScore;
          this.metricsTotal = this.metricsTotalScoreArray.reduce(
            (a: any, b: any) => {
              return Number(a) + Number(b);
            }
          );
        }
        
      // }else{
      //   this.restrictScore.nativeElement.value="";
        // const newElement = this.renderer.createElement('span');
        // this.renderer.setProperty(newElement,'class','error');
        // this.renderer.setStyle(newElement,'color','red');
        // newElement.innerHTML="Score value shoud be less than or equal "+this.restrictScore.nativeElement.max;
        //  this.renderer.appendChild(this.renderer.parentNode(this.restrictScore.nativeElement), newElement); 
  
        //  setTimeout(()=>{
        //  this.renderer.removeChild(this.renderer.parentNode(this.restrictScore.nativeElement), newElement, this.restrictScore.nativeElement.firstChild);
        //   },2000);
         
     // }
    
    }
    if (value === 'comment') {
      // if (this.getMetricsIndex === this.getMetricsIndex2) {
      //     this.metricsCommentsArray[this.getMetricsIndex] = this.metricsMComments;
      // } 
       var filter = /^[A-Za-z0-9]+(?:[A-Za-z0-9\/\&])+(?:\s[A-Za-z0-9\/\&\.]+)*[A-Za-z0-9\?\.]$/;

        if (!filter.test(this.metricsMComments)) {
          this.metricsMComments_valid = false;
          this.metricsCommentsArray[this.getMetricsIndex] = this.metricsMComments;
        }else{
           this.metricsMComments_valid = true;
           this.metricsCommentsArray[this.getMetricsIndex] = this.metricsMComments;
        } 
        
      
    }
  }

  updateMetricsManualField() {
    const obj = this.QAMetricsData.qa_metrics;
    for (let i = 0; this.metricsMatches.length > i; i++) {
      obj.metrics_matches[i].manual_score = this.metricsTotalScoreArray[i];
      obj.metrics_matches[i].manual_comments = this.metricsCommentsArray[i];
    }
    const qa_metrics_result = {
      metric_percentage: obj.metric_percentage,
      metric_score: obj.metric_score,
      metrics_matches: obj.metrics_matches,
    };
    obj;
    const obj1 = {
      fileid: this.storeId,
      qa_metrics: qa_metrics_result,
    };
    this.voicemailService.updateQAMetricsManual(obj1).subscribe(
      (sub:any) => {
        this.notifier.notify('default', 'Updated Successfully!');
        this.getMetricsIndex = -1;
        this.getQAMetricsData(this.selectedMetricsIndex);
      },
      (error:HttpErrorResponse) => {
        console.log('updated metrics feed', error);
      }
    );
  }

  updateMandatoryMetricsManualField(){
    const qa_metrics = this.QAMetricsData.qa_metrics;
    const obj = this.QAMetricsData.qa_metrics.metrics_matches.filter((matches:any)=>matches.type=="llm");
    for (let i = 0; this.metricsMatches.length > i; i++) {
        obj[i].manual_score = this.metricsTotalScoreArray[i];
        obj[i].manual_comments = this.metricsCommentsArray[i];
    }
    const qa_metrics_result = {
      metric_percentage: qa_metrics.metric_percentage,
      metric_score: qa_metrics.metric_score,
      metrics_matches: qa_metrics.metrics_matches,
    };
   
    const obj1 = {
      fileid: this.storeId,
      qa_metrics: qa_metrics_result,
    };
    this.voicemailService.updateQAMetricsManual(obj1).subscribe(
      (sub:any) => {
        this.notifier.notify('default', 'Updated Successfully!');
        this.getMetricsIndex = -1;
        this.getMandatoryRegulatorQAMetricsData(this.selectedMetricsIndex);
      },
      (error:HttpErrorResponse) => {
        console.log('updated metrics feed', error);
      }
    );
  }

  clearMetricsModalData() {
         this.tableData[this.selectedMetricsIndex]['metric_score'] = this.QAMetricsData?.qa_metrics?.metric_score;
    setTimeout(() => {
      this.metricsMatches = [];
      this.QAMetricsData = [];
      this.metricsCommentsArray = [];
      this.metricsTotalScoreArray = [];
      this.metricsTotal = 0;
      this.getMetricsIndex = -1;
      this.getMetricsIndex2 = -1;
    }, 400);
    this.showManualInput = false;
  }

  getIndex(index: number) {
    this.getRecordIndex = index;
  }

  showMultiSelectOption() {
    for (let i = 0; this.tableData.length > i; i++) {
      this.deleteIndexArray.push(false);
    }
    this.showMultiSelect = !this.showMultiSelect;
    this.selectedAllIndex = true;
    this.selectAll();
    if (this.showMultiSelect) {
      this.actionIconsIndex = -1;
    }
  }

  selectAll() {
    this.selectedAllIndex = !this.selectedAllIndex;
    for (let i = 0; this.deleteIndexArray.length > i; i++) {
      if (this.selectedAllIndex) {
        this.deleteIndexArray[i] = true;
      } else {
        this.deleteIndexArray[i] = false;
      }
    }
  }

  removeUnselected(index: any) {
    if (this.deleteIndexArray[index] === false) {
      this.deleteIndexArray[index] === false;
    } else {
      this.deleteIndexArray[index] === true;
    }
  }

  deleteSelectRecord(index: number) {
    if (index === 7000) {
      for (let i = 0; this.deleteIndexArray.length > i; i++) {
        if (this.deleteIndexArray[i] === true) {
          this.deleteIndexResult.push(i);
        }
      }
      for (let i = 0; this.deleteIndexResult.length > i; i++) {
        this.storeId = this.tableData[this.deleteIndexResult[i]]?.file_id.$oid;
        const obj = {
          fileid: this.storeId,
          filetype: 'audio',
        };
        this.storeFileIdArray.push(obj.fileid);
        this.storeDeleteApi.push(this.voicemailService.deleteRecord(obj));
      }
      forkJoin(this.storeDeleteApi).subscribe({
        next: (res:any) => {
          for (let i = 0; this.deleteIndexResult.length > i; i++) {
            const a = this.deleteIndexResult[i];
            for (let j = 0; this.tableData.length > j; j++) {
              if (
                this.storeFileIdArray[i] === this.tableData[j]?.file_id.$oid
              ) {
                this.tableData.splice(j, 1);
                this.records1.total_records = this.records1.total_records - 1;
              }
            }
          }
          this.deleteIndexResult = [];
          this.storeDeleteApi = [];
          this.storeId = '';
          this.storeFileIdArray = [];
          this.selectedAllIndex = false;
          this.clearDeleteArrayResult();
          if (!this.tableData.length) {
            this.audioPayload = {
              date_filter: 'false',
              pageno: 1,
              limit: this.limit,
              outbound: this.bound === 'inbound' ? false : true,
              sort: [{ property: 'created_date', dir: 'DESC' }],
              search: this.searchForm?.controls['searchInput'].value
                ? this.searchForm?.controls['searchInput'].value
                : '',
              meet_user: 'N',
              audio_call_type_status:'voice'
            };
            this.pageChanged(1);
          }
          this.notifier.notify('default', 'Deleted Successfully!');
        },
        error: (err:HttpErrorResponse) => {
          console.log('delete api error', err);
        },
      });
    } else {
      this.storeId = this.tableData[index]?.file_id.$oid;
      const obj = {
        fileid: this.storeId,
        filetype: 'audio',
      };
      this.voicemailService.deleteRecord(obj).subscribe(
        (sub:any) => {
          this.tableData.splice(index, 1);
          this.records1.total_records = this.records1.total_records - 1;
          this.notifier.notify('default', 'Deleted Successfully!');
        },
        (error:HttpErrorResponse) => {
          console.log(error);
        }
      );
    }
  }

  clearDeleteArrayResult() {
    this.deleteIndexArray = [];
    for (let i = 0; this.tableData.length > i; i++) {
      this.deleteIndexArray.push(false);
    }
  }
  getInfoData(index: number) {
    this.spinner = true;
    this.getTableIndex = index;
    this.infoDetails = this.tableData[index];
    // if (this.infoDetails.language.slice(0, 2) === 'en') {
    //   this.infoDetailsLanguage = 'English';
    // }
    // if (this.infoDetails.language.slice(0, 2) === 'hi') {
    //   this.infoDetailsLanguage = 'Hindi';
    // }
    // if (this.infoDetails.language.slice(0, 2) === 'es') {
    //   this.infoDetailsLanguage = 'Spanish';
    // }
    // if (this.infoDetails.language.slice(0, 2) === 'kn') {
    //   this.infoDetailsLanguage = 'Kannada';
    // }
    for (let i = 0; this.tranlateLanguages.length > i; i++) {
      if (
        this.tranlateLanguages[i].value ===
        this.infoDetails.language.slice(0, 2)
      ) {
        this.infoDetailsLanguage = this.tranlateLanguages[i].lang;
      }
    }
    const checkId = this.tableData[index].topic.toString();
    this.voicemailService.getInfo().subscribe(
      (sub:any) => {
        const data: any = sub;
        this.getInfoTopics = data.topics;
        this.storeId = this.tableData[index]?.topic;
        for (let i = 0; this.getInfoTopics.length > i; i++) {
          if (this.getInfoTopics[i].id.$oid === checkId) {
            var topicName = this.getInfoTopics[i].topic;
            this.setTopicId = this.getInfoTopics[i].id.$oid;
            var topicId = this.getInfoTopics[i].id.$oid;
          }
        }
        this.infoTopicsName = topicName;
        this.infoTopicsId = topicId;
        this.spinner = false;
        this.tableData[index].read = 'Y';
      },
      (error:HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  editInfoDetails() {
    const formObject = {
      display_file_name: this.infoDetails?.display_file_name,
      caller_name: this.infoDetails?.caller_name,
      agent_name: this.infoDetails?.agent_name,
      topic: this.infoTopicsId,
      own_key_words: this.infoDetails?.own_key_words,
      alert_keywords: this.infoDetails?.alert_keywords,
      sensitive_words: this.infoDetails?.sensitive_words,
      hide_keywords: this.infoDetails?.hide_keywords,
      delete_words: this.infoDetails?.delete_words,
      conversation: this.infoDetails?.conversation,
      language: this.infoDetailsLanguage,
    };

    this.infoEditShow = !this.infoEditShow;
    this.infoForm.patchValue(formObject);
  }

  updateInfoDetails() {
     this.infoForm.markAllAsTouched();
     if(this.infoForm.valid){
    this.getInfoFormValue = this.infoForm.value;
    this.getInfoTopicId = this.tableData[this.getTableIndex]?.file_id.$oid;
    const id = this.infoForm.controls['topic'].value;
    const formObj = {
      displayfilename: this.getInfoFormValue?.display_file_name,
      callername: this.getInfoFormValue?.caller_name,
      agentname: this.getInfoFormValue?.agent_name,
      topic: id,
      ownkeywords: this.getInfoFormValue?.own_key_words
        ? this.getInfoFormValue?.own_key_words.toString()
        : '',
      alertkeywords: this.getInfoFormValue?.alert_keywords
        ? this.getInfoFormValue?.alert_keywords.toString()
        : '',
      sensitivewords: this.getInfoFormValue?.sensitive_words
        ? this.getInfoFormValue?.sensitive_words.toString()
        : '',
      hidekeywords: this.getInfoFormValue?.hide_keywords
        ? this.getInfoFormValue?.hide_keywords.toString()
        : '',
      deletewords: this.getInfoFormValue?.delete_words
        ? this.getInfoFormValue?.delete_words.toString()
        : '',
      conversation: this.getInfoFormValue?.conversation
        ? this.getInfoFormValue?.conversation.toString()
        : '',
      language: this.infoDetails.language,
      //clientcode: this.userDetails?.email,
      tag: '',
      fileid: this.getInfoTopicId,
      inbound: this.tableData[this.getTableIndex].inboundcall,
    };
    this.voicemailService.updateInfo(formObj).subscribe({
      next:(sub:any) => {
        this.clearRecordData();
        this.loadAudioRecords();
        this.notifier.notify('default', 'Updated Successfully!');
      },
      error:(error:HttpErrorResponse) => {
        console.log('info update erro', error);
      }
     });
   }
  }

  clearRecordData() {
    setTimeout(() => {
      this.infoEditShow = false;
      this.infoDetails = [];
      this.infoTopicsName = '';
      this.infoForm.reset();
    }, 400);
  }
  openModalDialog(value?: string) {
    if (value === 'transcriptModal') {
      // setTimeout(() => {
      this.displayTranscriptModal = 'block';

      // }, 500);
    } else {
      if (this.audioFileIndex >= 0) {
        this.display = 'block'; //Set block css
      }
    }
  }
  closeAudioTag() {
    this.audioFileIndex = -1;
    this.showModalAudioTag = false;
  }
  closeModalDialog(value?: string) {
    if (value === 'transcriptModal') {
      this.displayTranscriptModal = 'none';
    }
    this.display = 'none'; //set none css after close dialog
  }
  sortFun() {
    if (this.audioFileIndex === -1) {
      if (!this.sortingShow) {
        // ascending order old to new
        const sortedAsc = this.tableData.sort(
          (objA: any, objB: any) =>
            new Date(objA.time_stamp).getTime() -
            new Date(objB.time_stamp).getTime()
        );
        this.sortingShow = !this.sortingShow;
      } else if (this.sortingShow) {
        // descending order new to old
        const sortedDesc = this.tableData.sort(
          (objA: any, objB: any) =>
            new Date(objB.time_stamp).getTime() -
            new Date(objA.time_stamp).getTime()
        );
        this.sortingShow = !this.sortingShow;
      }
    }
  }

  getReportData(index: number, value: string) {
    this.getDownload = value;
    if (this.transcribedLg.length > 1) {
      this.transcribedLg.shift();
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (this.getDownload === 'download') {
      this.getDownloadIndex = index;
    }
    if (value === 'keywordPercentage') {
      this.spinner = true;
      const id = this.tableData[index]?.file_id.$oid;
      this.infoDetails = this.tableData[index];
      this.downloadReportName = this.tableData[index]?.display_file_name;
      this.voicemailService.getTranscriptData(id,this.usersRole).subscribe({
        next: (response:any) => {
          this.transcriptModalData = response;
          this.keywordList = this.transcriptModalData.own_keywords_list;
          this.tableData[index].read = 'Y';
          this.keywordList.sort((a: any, b: any) => {
            return b.count - a.count;
          });
          const language = this.transcriptModalData.language;
          this.transcriptSelectedLgFun(language);
          this.spinner = false;
        },
        error: (err: HttpErrorResponse) => {
          console.log('report error', err);
          this.spinner = false;
        },
        complete: () => {
          this.spinner = false;
        },
      });
    } else {
      this.downloadSpinner = true;
      this.spinner = true;
      const id = this.tableData[index]?.file_id.$oid;
      this.infoDetails = this.tableData[index];
      this.downloadReportName = this.tableData[index]?.display_file_name;
      this.voicemailService.getTranscriptData(id,this.usersRole).subscribe({
        next: (response:any) => {
          this.transcriptModalData = response;
          this.dialogueList = this.transcriptModalData.dialogues_list;
          this.keywordList = this.transcriptModalData.own_keywords_list;
          this.alertkeywordList = this.transcriptModalData.alert_words_list;
          this.tableData[index].read = 'Y';
          this.keywordList.sort((a: any, b: any) => {
            return b.count - a.count;
          });
          this.alertkeywordList.sort((a: any, b: any) => {
            return b.count - a.count;
          });
          const language = this.transcriptModalData.language;
          this.transcriptSelectedLgFun(language);
          if (language.slice(0, 2) === 'en') {
            this.keywordSummary = this.transcriptModalData.keywords;
            this.mostUsedWords = this.transcriptModalData.most_used_words;
          } else {
            this.keywordSummary = this.transcriptModalData.spanish_keywords;
            this.mostUsedWords =
              this.transcriptModalData.spanish_most_used_words;
          }
        },
        error: (err: any) => {
          console.log('report error', err);
          this.spinner = false;
        },
        complete: () => {
          this.downloadSpinner = false;
        },
      });

      this.voicemailService.getQuestionData(id,this.usersRole).subscribe({
        next: (response:any) => {
          this.questionsData = response;
          this.transcriptSelectedLgFun(this.questionsData.language);
          if (this.questionsData.language.slice(0, 2) === 'en') {
            this.englishQuestions = this.questionsData.english_questions;
          } else {
            this.englishQuestions = this.questionsData.spanish_questions;
          }
        },
        error: (err: HttpErrorResponse) => {
          console.log('report question error', err);
          this.spinner = false;
        },
        complete: () => {
          this.downloadSpinner = false;
          if (this.getDownload === 'download') {
            this.makePDF();
          } else {
            this.spinner = false;
          }
        },
      });
    }
  }

  async makePDF() {
    this.downloadBtnSpinner = true;
    let doc = new jsPDF();
    doc.setFontSize(22);
    doc.setTextColor(25, 118, 210);
    doc.text('Recorded Call Analysis Report', 105, 10, { align: 'center' });
    if (
      this.transcribedLgVariable !== 'Hindi' &&
      this.transcribedLgVariable !== 'Tamil' &&
      this.transcribedLgVariable !== 'Kannada' &&
      this.transcribedLgVariable !== 'Telugu'
    ) {
      autoTable(doc, {
        html: '#report-top-details',
        theme: 'grid',
        includeHiddenHtml: true,
        margin: { top: 20 },
        columnStyles: {
          0: { textColor: [0, 0, 0] },
          2: { textColor: [0, 0, 0] },
        },
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      await html2canvas(document.getElementById('sentimentCard3')!, {
        allowTaint: false,
        useCORS: false,
        imageTimeout: 1000,
        scale: 2,
        onclone: (cloneDoc) => {
          cloneDoc.getElementById('sentimentCard3')!.style.display = 'block';
        },
      }).then((canvas) => {
        var imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 40, 52, 130, 50);
      });

      autoTable(doc, {
        html: '#transcriptReport',
        theme: 'grid',
        startY: 110,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        columnStyles: this.dialogueList.length
          ? { 0: { cellWidth: 25, textColor: [0, 0, 0] } }
          : {},
        bodyStyles: { fontSize: 12 },
      });
      autoTable(doc, {
        html: '#question-answer-report',
        theme: 'grid',
        pageBreak: 'avoid',
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        columns: [{ header: 'Keyword/Phrases' }],
        html: '#keyword-phrases-table-report',
        theme: 'grid',
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        columns: [{ header: 'Most Used Words' }],
        html: '#most-used-words-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });
      doc.save(this.downloadReportName + '' + '.pdf');
      this.downloadBtnSpinner = false;
      this.spinner = false;
      this.getDownloadIndex = -1;
      if (this.transcribedLg_T.length > 1) {
        this.transcribedLg_T.shift();
        this.transcribedLgVariable_T = this.transcribedLg_T[0];
      }
    } else {
      if (this.transcribedLgVariable === 'Hindi') {
        this.fontLanguage = hindiText;
        this.ttfName = 'NotoSansDevanagari-VariableFont_wdth,wght-normal.ttf';
        this.fontName = 'NotoSansDevanagari-VariableFont_wdth,wght';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Tamil') {
        this.fontLanguage = tamilText;
        this.ttfName = 'New_Kannan_Text-normal.ttf';
        this.fontName = 'New_Kannan_Text';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Kannada') {
        this.fontLanguage = kannadaText;
        this.ttfName = 'BalooTamma2-Regular-normal.ttf';
        this.fontName = 'BalooTamma2-Regular';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Telugu') {
        this.fontLanguage = teluguText;
        this.ttfName = 'HindGuntur-Regular-normal.ttf';
        this.fontName = 'HindGuntur-Regular';
        this.fontStyle = 'normal';
      }
      doc.addFileToVFS(this.ttfName, this.fontLanguage);
      doc.addFont(this.ttfName, this.fontName, this.fontStyle);
      doc.setFont(this.fontName);
      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#report-top-details',
        theme: 'grid',
        includeHiddenHtml: true,
        margin: { top: 20 },
        headStyles: {
          fillColor: [25, 118, 210],
          fontSize: 12,
          fontStyle: 'bold',
        },
        bodyStyles: { fontSize: 12 },
      });

      await html2canvas(document.getElementById('sentimentCard3')!, {
        allowTaint: false,
        useCORS: false,
        imageTimeout: 1000,
        scale: 2,
        onclone: (cloneDoc:any) => {
          cloneDoc.getElementById('sentimentCard3')!.style.display = 'block';
        },
      }).then((canvas:any) => {
        var imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 40, 52, 130, 50);
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#transcriptReport',
        theme: 'grid',
        startY: 110,
        headStyles: {
          fillColor: [25, 118, 210],
          fontSize: 12,
          fontStyle: 'bold',
        },
        columnStyles: this.dialogueList.length ? { 0: { cellWidth: 25 } } : {},
        bodyStyles: { fontSize: 12 },
      });
      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#question-answer-report',
        theme: 'grid',
        pageBreak: 'avoid',
        headStyles: {
          fillColor: [25, 118, 210],
          fontSize: 12,
          fontStyle: 'bold',
        },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        columns: [{ header: 'Keyword/Phrases' }],
        html: '#keyword-phrases-table-report',
        theme: 'grid',
        headStyles: {
          fillColor: [25, 118, 210],
          fontSize: 12,
          fontStyle: 'bold',
        },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        columns: [{ header: 'Most Used Words' }],
        html: '#most-used-words-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: {
          fillColor: [25, 118, 210],
          fontSize: 12,
          fontStyle: 'bold',
        },
        bodyStyles: { fontSize: 12 },
      });
      doc.save(this.downloadReportName + '' + '.pdf');
      this.downloadBtnSpinner = false;
      this.spinner = false;
      this.getDownloadIndex = -1;
      if (this.transcribedLg_T.length > 1) {
        this.transcribedLg_T.shift();
        this.transcribedLgVariable_T = this.transcribedLg_T[0];
      }
    }
  }

  searchTableData(value: string) {
    this.getInputSearchValue = value;
    if (this.selectedSearchOption === 'default') {
      this.audioPayload = {
        date_filter: 'false',
        pageno: 1,
        limit: this.limit,
        outbound: this.bound === 'inbound' ? false : true,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: this.getInputSearchValue ? this.getInputSearchValue : '',
        meet_user: 'N',
        audio_call_type_status:'voice'
      };
      this.pageChanged(1);
    } else if (this.selectedSearchOption === 'keyword') {
      this.audioPayload = {
        date_filter: 'false',
        pageno: 1,
        limit: this.limit,
        outbound: this.bound === 'inbound' ? false : true,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: this.getInputSearchValue ? this.getInputSearchValue : '',
        meet_user: 'N',
        audio_call_type_status:'voice'
      };
      this.pageChanged(1);
    } else if (this.selectedSearchOption === 'date') {
      this.pageChanged(1);
    }else if (this.selectedSearchOption === 'fileid') {
      this.audioPayload = {
        date_filter: 'false',
        pageno: 1,
        limit: this.limit,
        outbound: this.bound === 'inbound' ? false : true,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        audio_call_id: this.getInputSearchValue ? this.getInputSearchValue : '',
        search:'',
        meet_user: 'N',
        audio_call_type_status:'voice'
        
      };
      this.pageChanged(1);
    } 
  }

  getKeywordSearchData() {
    this.bodySpinner = true;
    this.voicemailService.postSearchKeyword(this.audioPayload).subscribe({
      next: (response:any) => {
        this.records1 = response;
        this.tableData = this.records1.records;
        if(this.tableData.length==this.limit){
          this.showingRecords = this.limit * this.page;
        }else{
          this.showingRecords = this.limit * (this.page - 1) + this.tableData.length;
        }
        this.getMatchedCategory(this.tableData);
        this.bodySpinner = false;
      },
      error: (err:HttpErrorResponse) => {
        console.log('keyword search error', err);
        this.bodySpinner = false;
      },
      complete: () => { },
    });
  }

  getDateSearchData(value: any) {
    this.getDateData = value;
    this.endDate = this.getDateData?.endDate?.$d;
    var tempEndDate = new Date(this.endDate);
    tempEndDate.setDate(tempEndDate.getDate() - 1);
    const startDate = new DatePipe('en-US').transform(
      this.getDateData?.startDate?.$d || '',
      'MM-dd-yyyy'
    );
    const endDate = new DatePipe('en-US').transform(
      tempEndDate || '',
      'MM-dd-yyyy'
    );
    if (startDate) {
      this.audioPayload = {
        date_filter: 'true',
        pageno: 1,
        limit: this.limit,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: '',
        meet_user: 'N',
        outbound: this.bound === 'inbound' ? false : true,
        start_date: startDate ? startDate?.toString() : '',
        end_date: endDate ? endDate?.toString() : '',
        audio_call_type_status:'voice'
      };
      this.pageChanged(1);
    }
  }

  selectTableData() {
    this.tableSearch = '';
    this.getDateData = '';
    // this.pickerDirective?.clear();
    this.selectedSearchOption = this.searchSelect.nativeElement.value;
    console.log("this.selectedSearchOption",this.selectedSearchOption);
    if (this.selectedSearchOption === 'default') {
      this.audioPayload = {
        date_filter: 'false',
        pageno: 1,
        limit: this.limit,
        outbound: this.bound === 'inbound' ? false : true,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: '',
        meet_user: 'N',
        audio_call_type_status:'voice'
      };
      this.pageChanged(1);
    } else if (this.selectedSearchOption === 'keyword') {
      this.audioPayload = {
        date_filter: 'false',
        pageno: 1,
        limit: this.limit,
        outbound: this.bound === 'inbound' ? false : true,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: '',
        meet_user: 'N',
        audio_call_type_status:'voice'
      };
      this.pageChanged(1);
    } else if (this.selectedSearchOption === 'date') {
      this.audioPayload = {
        date_filter: 'false',
        pageno: 1,
        limit: this.limit,
        outbound: this.bound === 'inbound' ? false : true,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: '',
        meet_user: 'N',
        audio_call_type_status:'voice'
      };
      this.pageChanged(1);
    }else if (this.selectedSearchOption === 'fileid') {
      this.audioPayload = {
        date_filter: 'false',
        pageno: 1,
        limit: this.limit,
        outbound: this.bound === 'inbound' ? false : true,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        audio_call_id: '',
        search: '',
        meet_user: 'N',
        audio_call_type_status:'voice'
      };
      this.pageChanged(1);
    }
  }
  openAccordion() {
    // this.showAccordionData = true;
  }

  toggleAcButton(value: string) {
    if (value !== 'name') {
      this.speakerNameAcButton.nativeElement.click();
    }
    if (value !== 'conversation') {
      this.conversationAcButton.nativeElement.click();
    }
  }

  changeTranscriptLgFun() {
    this.searchText = '';
    if (this.transcribedLgVariable_T === 'English') {
      this.englishQuestions_T = this.questionsData_T.english_questions;
      this.mostUsedWords_T = this.transcriptModalData_T.most_used_words;
      this.keywordSummary_T = this.transcriptModalData_T.keywords;
    } else {
      this.englishQuestions_T = this.questionsData_T.spanish_questions;
      this.mostUsedWords_T = this.transcriptModalData_T.spanish_most_used_words;
      this.keywordSummary_T = this.transcriptModalData_T.spanish_keywords;
    }
    if (this.showRow) {
      this.getEditingText(this.dialogueIndex);
    }
    this.globalSearchHighlighterFun();
  }
  changeTranscriptLgReport() {
    if (this.transcribedLgVariable === 'English') {
      this.englishQuestions = this.questionsData.english_questions;
      this.mostUsedWords = this.transcriptModalData.most_used_words;
      this.keywordSummary = this.transcriptModalData.keywords;
    } else {
      this.englishQuestions = this.questionsData.spanish_questions;
      this.mostUsedWords = this.transcriptModalData.spanish_most_used_words;
      this.keywordSummary = this.transcriptModalData.spanish_keywords;
    }
  }

  hideMinimizedModal(value: string) {
    if (value === 'Transcript') {
      this.transcriptMinimizedBoolean = false;
      this.transcriptMinimizedHeader = '';
    }
  }

  showMinimizedModal(value: string) {
    if (value === 'Transcript') {
      this.transcriptMinimizedBoolean = true;
      this.transcriptMinimizedHeader = value;
    }
  }

  modalFullScreen(value: string) {
    if (value === 'max') {
      this.modalScreenSize = 'modal-fullscreen';
    }
    if (value === 'min') {
      this.modalScreenSize = '';
    }
  }

  getEmailData(index: number) {
    this.spinner = true;
    var data: any[] = [];
    this.storeId = this.tableData[index]?.file_id.$oid;
    this.voicemailService.getTranscriptData(this.storeId,this.usersRole).subscribe({
      next: (response:any) => {
        this.transcriptModalData = response;
        this.dialogueList = this.transcriptModalData.dialogues_list;
        for (let i = 0; this.dialogueList.length > i; i++) {
          data.push(this.dialogueList[i].edited_text);
          this.spinner = false;
        }
        this.emailForm.controls['htmlContent'].setValue(data);
      },
      error: (err:HttpErrorResponse) => {
        console.log('transcription api', err);
        this.spinner = false;
      },
    });
  }

  sendMailData() {
    const obj = {
      body: this.emailForm.controls['htmlContent'].value
        ? this.emailForm.controls['htmlContent'].value.toString()
        : '',
      cc: this.emailForm.controls['cc'].value
        ? this.emailForm.controls['cc'].value.toString()
        : '',
      fileid: this.storeId,
      subject: this.emailForm.controls['subject'].value
        ? this.emailForm.controls['subject'].value
        : '',
      to: this.emailForm.controls['to'].value.toString(),
    };
    this.voicemailService.sendMail(obj).subscribe({
      next: (response:any) => {
        this.notifier.notify('default', 'Mail sent successfully');
      },
      error: (err:HttpErrorResponse) => {
        console.log('mail api error', err);
      },
    });
  }

  clearEmailData() {
    setTimeout(() => {
      this.transcriptModalData = [];
      this.dialogueList = [];
      this.emailForm.reset();
    }, 400);
  }

  getDeadAirData(index: number) {
    this.deadAirFileIndex = index;
    if (this.tableData[index].dead_air?.[0]) {
      this.deadAirDurationData = this.deadAirData[index]?.dead_air_duration;
    } else {
      this.deadAirDurationData = this.deadAirDataNew[index]?.duration;
    }

    if(this.deadAirDurationData.length > 0){
      let datavalue:any=[]
      for(let dataArray in this.deadAirDurationData){
        let duration = this.calculateDuration(this.deadAirDurationData[dataArray][1],this.deadAirDurationData[dataArray][0]);
        //  let duration = this.deadAirDurationData[dataArray].reduce((a:any,b:any)=> {
        //     return parseFloat(b) - parseFloat(a);
        //    });
           datavalue.push(duration);
      }
      this.softHold_Totalduration = datavalue.reduce((accumulator:any, current:any) => accumulator + current);
   
    }

  }

  getSoftHoldData(index: number) {
    this.softHoldDurationData = this.softHoldData[index]?.hold_duration;
    this.softHold_Totalduration = "";
    if(this.softHoldDurationData.length > 0){
      let datavalue:any=[]
      for(let dataArray in this.softHoldDurationData){
        let duration = this.calculateDuration(this.softHoldDurationData[dataArray][1],this.softHoldDurationData[dataArray][0]);
        //  let duration = this.softHoldDurationData[dataArray].reduce((a:any,b:any)=> {
        //     return parseFloat(b) - parseFloat(a);
        //    });
           datavalue.push(duration);
      }
      this.softHold_Totalduration = datavalue.reduce((accumulator:any, current:any) => accumulator + current);
   
    }
  }

  getTranslateDataFun_1(index: number) {
    this.spinner = true;
    this.storeId = this.tableData[index]?.file_id.$oid;
    this.displayName = this.tableData[index]?.display_file_name;
    this.voicemailService.getTranscriptionOriginalText(this.storeId).subscribe({
      next: (response:any) => {
        this.editedTextBoolean = true;
        this.translateResponseData_originalTemp = response;
        this.translateResponseData_original =
          this.translateResponseData_originalTemp?.dialogues_list;
        this.getTranslateLanguage =
          this.translateResponseData_originalTemp?.language.slice(0, 2);
        for (let i = 0; this.tranlateLanguages.length > i; i++) {
          if (this.tranlateLanguages[i].value === this.getTranslateLanguage) {
            this.selectedTranslate_1 = this.tranlateLanguages[i].lang;
          }
        }
        if (this.getTranslateLanguage === 'en') {
          this.fromLanguage = this.tranlateLanguages[0].value;
          this.selectedTranslate = this.tranlateLanguages[1].lang;
          this.toLanguage = this.tranlateLanguages[1].value;
          this.translateTextData(this.tranlateLanguages[1].value);
          for (let i = 0; this.translateResponseData_original.length > i; i++) {
            this.translateResponseData_originalTemp.dialogues_list[
              i
            ].spanish_edited_text = this.translateResponseData[i]?.text;
          }
        } else {
          for (let i = 0; this.tranlateLanguages.length > i; i++) {
            if (this.tranlateLanguages[i].value === this.getTranslateLanguage) {
              this.toLanguage = this.tranlateLanguages[i].value;
            }
          }
          this.fromLanguage = this.tranlateLanguages[0].value;
          this.selectedTranslate = this.tranlateLanguages[0].lang;
        }
        this.spinner = false;
      },
      error: (err:HttpErrorResponse) => {
        this.spinner = false;
        console.log('translate api error', err);
      },
    });
  }

  translateTextData(formValue: any) {
    if (
      this.getTranslateLanguage === 'en' &&
      !this.translateResponseData_originalTemp.dialogues_list[0]
        .spanish_edited_text
    ) {
      this.spinner = true;
    } else {
      this.translateSpinner = true;
    }
    if (formValue === 'en') {
      this.fromLanguage = 'es';
    } else {
      this.fromLanguage = 'en';
    }
    if (this.editedTextBoolean) {
      this.editedTextPayload = this.translateResponseData_original.map(
        (event: { dialogue_id: number; edited_text: string }) => ({
          dialogue_id: event.dialogue_id,
          text: event.edited_text,
        })
      );
    }
    this.toLanguage = formValue;
    const payload = {
      fromlanguage: this.fromLanguage,
      tolanguage: this.toLanguage,
      type: 1,
      dialogue_list: this.editedTextPayload,
      fileid: this.storeId,
    };
    this.voicemailService.getTranslatedLanguageData(payload).subscribe({
      next: (response:any) => {
        this.translateResponseDataTemp = response;
        this.translateResponseData =
          this.translateResponseDataTemp?.result_list;
        for (let i = 0; this.translateResponseData.length > i; i++) {
          this.translateResponseData_originalTemp.dialogues_list[
            i
          ].edited_text = this.translateResponseData[i]?.translated_text;
        }
        if (
          this.getTranslateLanguage === 'en' &&
          !this.translateResponseData_originalTemp.dialogues_list[0]
            .spanish_edited_text
        ) {
          for (let i = 0; this.translateResponseData_original.length > i; i++) {
            this.translateResponseData_originalTemp.dialogues_list[
              i
            ].spanish_edited_text = this.translateResponseData[i]?.text;
          }
        }
        this.spinner = false;
        this.translateSpinner = false;
        this.editedTextBoolean = false;
      },
      error: (err:HttpErrorResponse) => {
        console.log('translate api error', err);
        this.translateSpinner = false;
        this.spinner = false;
      },
    });
  }

  clearTranslateModalData() {
    setTimeout(() => {
      this.translateResponseData_originalTemp = [];
      this.translateResponseData_original = [];
      this.translateResponseData = [];
      this.translateResponseDataTemp = [];
      this.fromLanguage = '';
      this.toLanguage = '';
      this.storeId = '';
      this.selectedTranslate = '';
      this.selectedTranslate_1 = '';
    }, 400);
  }

  globalSearchHighlighterFun() {
    setTimeout(() => {
      if (this.tableSearch) {
        this.searchText = this.tableSearch;
      } else {
        this.searchText = '';
      }
    }, 200);
  }

  showActionIconsFun(value: string, index: number) {
    if (value === 'show') {
      this.showActionIcons = true;
      if (this.showMultiSelect) {
        this.showMultiSelect = false;
        this.selectAll();
        this.storeDeleteApi = [];
        this.deleteIndexArray = [];
        this.deleteIndexResult = [];
        this.storeFileIdArray = [];
      }
    } else {
      this.showActionIcons = false;
    }
    this.actionIconsIndex = index;
  }

  validateSoftHoldIcon(hold_key:any){
    
    if(hold_key.hold_duration.length > 0){
      let firstdata = hold_key.hold_duration[0];
      if(this.bound=="inbound"){
        if(Math.floor(firstdata[0]) <= 10){
          return 'neutral-icon';
        }else{
          return 'hold-icon';
        }
      }else{
        if(Math.floor(firstdata[0]) <= 5){
          return 'neutral-icon';
        }else{
          return 'hold-icon';
        }
      }
     
    }else{
      return 'neutral-icon';
    }
      // if(hold_key.hold_duration.length > 0){
      //   return 'hold-icon';
      //   if(hold_key.hold_duration.length > 0){
      //     let getMinutes = hold_key.hold_duration[0].split(",")[0].split(".")[0];
       
      //     if(getMinutes <= 10){
      //       return 'neutral-icon';
      //     }else{
      //       return 'hold-icon';
      //     }
         
      //   }else{
      //     return 'neutral-icon';
      //   }
       
       
      // } else{
      //   return 'neutral-icon';
      // }

       
      
  }

  validateSoftHoldDurationIcon(hold_duration:any){
    let getMinutes = hold_duration[0].split(",")[0].split(".")[0];
     if(getMinutes > 60){
        return true;
     }
     return false;
  }


  validate_numeric_agent_score(agentScore:any){
    //number : '1.0-1'
   if(typeof agentScore=='string'){
      return agentScore;
    }else{
      return this.decimalPipe.transform(agentScore,this.format_agent_score);
    }
  }

  validate_QA_Score(metrics_matches:any,metric_score:number){
     return this.validate_numeric_agent_score(metric_score);
  }


  validate_Mandatory_QA_Score(llm_total_score:number){
    return this.validate_numeric_agent_score(llm_total_score);
  }

  drawProgressBar(metric_score:any){
    let progress:any;
    if(metric_score==0){
      progress = 'progress-bar0';
    }else if(metric_score > 0 && metric_score <= 40){
      progress = 'progress-barLightGreen';
    }else if(metric_score > 40 && metric_score <= 70){
      progress = 'progress-barLightBlue';
    }
    else if(metric_score > 70 && metric_score <= 100){
      progress = 'progress-barGreen';
    }
    return progress;
  }

  calculateDuration(end_time:any,start_time:any){
    const st_seconds = start_time.toString().split(".")[0];
    const ed_seconds = end_time.toString().split(".")[0];
  

    const start_seconds = (st_seconds * 60) ;
    const end_seconds = (ed_seconds * 60);
    const remain_seconds = Math.floor(end_seconds - start_seconds);
    const minutes = Math.floor((remain_seconds % 3600) / 60);
    return Math.round(ed_seconds - st_seconds);
  
  }



  getMandatoryRegulatorQAMetricsData(index: number) {
    this.selectedMetricsIndex=index;
    this.metricFullscreen=true;
    this.spinner = true;
    this.storeId = this.tableData[index]?.file_id.$oid;
    const obj: any = { fileid: this.storeId };
    this.voicemailService.getQAMetric(obj).subscribe(
      (sub:any) => {
        this.QAMetricsData = sub;
        this.metricsMatches = this.QAMetricsData.qa_metrics.metrics_matches.filter((matches:any)=>matches.type=="llm");
        this.spinner = false;
        this.tableData[index].read = 'Y';
        let manual_score_data = this.QAMetricsData.qa_metrics.manual_score_data.filter((matches:any)=>matches.type=="llm");
       // const length = this.metricsMatches.length;
       const length = manual_score_data.length;
        this.metricsTotal = this.QAMetricsData.qa_metrics.manual_total;
        for (let i = 0; length > i; i++) {
          this.metricsTotalScoreArray.push(
            manual_score_data[i]?.manual_score
          );
          this.metricsCommentsArray.push(
            manual_score_data[i]?.manual_comments
          );
        }
     
        
      },
      (error:HttpErrorResponse) => {
         this.notifier.notify('default',error['error']['message']);
      }
    );
  }

  drawBadge(matric_matches:any,fieldName:any){
      return matric_matches.filter((field:any)=>field.category==fieldName).map((data:any)=> { return data['agent_score'] });
  }

  showMatchKeywords(matric_matches:any,fieldName:any){
    return matric_matches.filter((field:any)=>field.category==fieldName).map((data:any)=> { 
      if(data['matched_keywords'].length > 0){
        return 'Matched Keywords: '+ data['matched_keywords'].join(" , ");
     }else{
      return 'Matched Keywords Not Found';
     }
    });
  }

  ngAfterViewInit(){
    let user = localStorage.getItem("user");
    if(user){
        var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
        this.userDetails = JSON.parse(data);
        this.usersRole = this.userDetails?.role;
        this.condition_email = this.userDetails?.email;
    }   
  }

   onKeywordsAdded(event:any,controlName:string){
    var filter = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;

        if (!filter.test(event.value)) {
            this.notifier.notify('error','Please provide a valid keywords');
            let tag_value =  this.infoForm.get(controlName)?.value;
            tag_value.splice(tag_value.length-1,1);
        }
 }

}
